// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  crmApi: {
    baseUrl: 'https://crm-api.cp.kodeinda.cloud/crm'
  },
  api: {
    baseUrl: 'https://emr-api.cp.kodeinda.cloud/emr'
  },
  auth: {
    baseUrl: 'https://crm-api.cp.kodeinda.cloud/crm'
  },
  serverApiKey:
    'hXqTr8IyWZeFJHL5L0LlnpNZDStdE0k8iQJsKIuf81LF2mHLNUuMrgNFUiFP8Oi8',
  realmAppId: 'mongomanager-pemtk',
  dbName: 'jackhealth-platform',
  realmServiceName: 'mongodb-atlas-servie',
  bigcommerce_view_order_url:
    'https://store-uhbiktm366.mybigcommerce.com/manage/orders/{orderId}',
  firebaseConfig: {
    apiKey: 'AIzaSyBMG4318ece8D738Ok8TBZiOqXZwvYglmY',
    authDomain: 'portals-care.firebaseapp.com',
    databaseURL: 'https://portals-care-default-rtdb.firebaseio.com',
    projectId: 'portals-care',
    storageBucket: 'portals-care.appspot.com',
    messagingSenderId: '338418690450',
    appId: '1:338418690450:web:371c7aee95c5c7d3c5b94b',
    measurementId: 'G-RPFFVRBYNJ'
  }
};
